document.documentElement.classList.remove('no-js');

window.theme = window.theme || {};

/* ---------- Swap a section's rendered HTML in place (Shopify `sections` API) ---------- */
window.theme.replaceSectionFragment = function (elementId, fragmentHtml) {
  var old = document.getElementById(elementId);
  if (!old || !fragmentHtml) return null;
  var wrapper = document.createElement('div');
  wrapper.innerHTML = fragmentHtml;
  var replacement = wrapper.querySelector('#' + elementId);
  if (!replacement) return null;
  old.replaceWith(replacement);
  return replacement;
};

/* ---------- Money formatting (mirrors Shopify's money_format filter) ---------- */
window.theme.formatMoney = function (cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  format = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';

  function defaultTo(value, fallback) {
    return value == null || value !== value ? fallback : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var match = format.match(placeholderRegex);

  switch (match ? match[1] : '') {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return format.replace(placeholderRegex, value);
};

/* ---------- Announcement bar rotation ---------- */
(function initAnnouncementBar() {
  var bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;
  var items = bar.querySelectorAll('.announcement-bar__item');
  if (items.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
  var index = 0;

  setInterval(function () {
    items[index].hidden = true;
    index = (index + 1) % items.length;
    items[index].hidden = false;
  }, interval);
})();

/* ---------- Sticky header ---------- */
(function initStickyHeader() {
  var header = document.querySelector('[data-header]');
  if (!header) return;
  var mode = header.getAttribute('data-sticky');
  if (!mode) return;

  var sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'position:absolute;top:0;left:0;height:1px;width:1px;';
  header.insertAdjacentElement('beforebegin', sentinel);

  new IntersectionObserver(function (entries) {
    header.classList.toggle('header--scrolled', !entries[0].isIntersecting);
  }).observe(sentinel);

  if (mode !== 'on-scroll-up') return;

  var lastY = window.scrollY;
  var ticking = false;

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var currentY = window.scrollY;
      var scrollingDown = currentY > lastY && currentY > header.offsetHeight;
      header.classList.toggle('header--hidden', scrollingDown);
      lastY = currentY;
      ticking = false;
    });
  }, { passive: true });
})();

/* ---------- Mobile menu drawer ---------- */
(function initMenuDrawer() {
  var drawer = document.getElementById('MenuDrawer');
  var toggle = document.querySelector('[data-menu-drawer-toggle]');
  var closeBtn = document.querySelector('[data-menu-drawer-close]');
  if (!drawer || !toggle) return;

  toggle.addEventListener('click', function () {
    drawer.showModal();
    toggle.setAttribute('aria-expanded', 'true');
  });

  function close() {
    drawer.close();
    toggle.setAttribute('aria-expanded', 'false');
  }

  if (closeBtn) closeBtn.addEventListener('click', close);
  drawer.addEventListener('click', function (event) {
    if (event.target === drawer) close();
  });
  drawer.addEventListener('close', function () {
    toggle.setAttribute('aria-expanded', 'false');
  });
})();

/* ---------- Cart icon: defer to cart drawer dialog if present ---------- */
(function initCartIcon() {
  var cartIcon = document.querySelector('[data-cart-icon]');
  if (!cartIcon) return;

  cartIcon.addEventListener('click', function (event) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return; // no drawer yet: let the link go to /cart
    event.preventDefault();
    drawer.showModal();
  });
})();

/* ---------- Header cart count: stays in sync after any AJAX cart change ---------- */
(function initCartCountSync() {
  var countEl = document.querySelector('[data-cart-count]');
  if (!countEl) return;

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    countEl.textContent = cart.item_count;
    countEl.hidden = cart.item_count === 0;
  });
})();

/* ---------- Toast notifications ---------- */
window.theme.showToast = function (message) {
  var toast = document.getElementById('ThemeToast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'ThemeToast';
    toast.className = 'theme-toast';
    toast.setAttribute('role', 'status');
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.classList.add('is-visible');
  window.clearTimeout(toast._hideTimer);
  toast._hideTimer = window.setTimeout(function () {
    toast.classList.remove('is-visible');
  }, 2600);
};

/* ---------- Quick add to cart (product cards) ---------- */
(function initQuickAdd() {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quick-add]');
    if (!button || button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.disabled = true;

    fetch(window.theme.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: 'cart-drawer' })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Could not add to cart');

        if (window.theme.settings.cartType === 'drawer') {
          var newDrawer = window.theme.replaceSectionFragment('CartDrawer', data.sections && data.sections['cart-drawer']);
          if (newDrawer) newDrawer.showModal();
        } else {
          window.theme.showToast(window.theme.strings.addedToCart);
        }

        return fetch(window.theme.routes.cartUrl + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function (error) {
        window.theme.showToast(error.message);
      })
      .finally(function () {
        button.disabled = false;
      });
  });
})();
